export default "__VITE_ASSET__b4ff7694__"